(function(factory){
    if(typeof module!=="undefined" && module.exports) {
        module.exports=factory;
    } else {
        factory(jQuery,window,document);
    }
}(function($) {
	/**
	 *
	 * @param el
	 * @param options
	 */
    $.id_tabs = function(el, options) {
        const _this = this;
        this.$element = $(el);
        this.init = function(){
            this.options = $.extend({}, $.id_tabs.defaultOptions, options);
			// First, link event listeners
			this.$element.find('ul li a').off('click').on('click', function (e) {
				e.preventDefault();
				_this.setActiveTab(this);
			});

            // if we manage history, then manage it...
            if (this.options.handleHistory) {
				// let's check for an URL hash, if found and a tab with the right ID exists, show it.
				let hash = window.location.hash;
				if ( hash ) {
					const $tabToShow = $(hash, this.$element);
					if ($tabToShow.length) {
						$('a[href*="'+ hash +'"]').parent().addClass('active');
						$tabToShow.fadeIn();
					} else {
						// @todo see below
						this.$element.find('ul li:first-child a').trigger('click');
					}
				} else {
					// if tab not found,
					// set active class to first tab menu + content
					// this.$element.find('ul li:first-child').addClass('active');
					// this.$element.find('.tab-content').first().addClass('active');
					// @todo see if better click (always add # to url, below) or activate classes to preserve url (above, bugged)
					this.$element.find('ul li:first-child a').trigger('click');
				}
			}

        };

		/**
		 * Add new tab to history
		 * @param segment
		 */
		this.setHistory = function (segment) {
			if (window.history && window.history.pushState) {
				history.pushState("", document.title, segment);
			}
        }

		/**
		 * Set active tab
		 * @param object
		 */
		this.setActiveTab = function (object) {
        	const $link = $(object);
			if (!$link.hasClass('active')) {
				const $li = $link.parent();
				// link classes
				$li.siblings().removeClass('active');
				$li.addClass('active');
				const hash = $link.attr('href');
				// manage tabs
				const $tab = $(hash, this.$element);
				$tab.siblings().removeClass('active').hide();
				$tab.fadeIn();
				// manage history
				if (this.options.handleHistory) {
					this.setHistory(hash);
				}
			}
		}
        this.init();
    };

    $.id_tabs.defaultOptions = {
		'handleHistory': false
    };

    $.fn.id_tabs = function(options) {
        return this.each(function() {
            (new $.id_tabs(this, options));
        });
    };
}));
